import React, { FC, ReactNode } from 'react';

import COLOR_SCHEMES from '../../../constants/COLOR_SCHEMES';
import { BlockProps } from '../Block';

import { StyledBlock } from './EmphasisBlock.styles';

export interface EmphasisBlockProps extends BlockProps {
  /** The block's content */
  children: ReactNode;
}

/**
 * @since 0.18.0
 */
const EmphasisBlock: FC<EmphasisBlockProps> = (props) => (
  <StyledBlock
    {...props}
    colorScheme={COLOR_SCHEMES.LIGHT}
  />
);

export default EmphasisBlock;
